import { IdsInput, SuccessMessageResponse } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function sendFriendlyContractReminderToStaffs(input: IdsInput) {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.sendFriendlyContractReminderToStaffs.url, null))
    .post<SuccessMessageResponse, IdsInput>(input)
}

export function sendFriendlyMissingDocumentsReminderToStaffs(input: IdsInput) {
  return restApiClient
    .url(
      constructApiUrl(API.affectedStaffs.sendFriendlyMissingDocumentsReminderToStaffs.url, null)
    )
    .post<SuccessMessageResponse, IdsInput>(input)
}
